import React, { useRef, useEffect } from 'react';
import { Button, ButtonProps } from './Button';

export interface EnterAwareButtonProps extends ButtonProps {}

export const EnterAwareButton: React.FC<EnterAwareButtonProps> = props => {
  const { value, ...rest } = props;
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    // This is meant to allow for form submission without
    // focus via the 'enter' key
    const listenForEnter = (e: KeyboardEvent) => {
      // Wrap this event so that it's easy to reliably get the key
      const syntheticEvent = new KeyboardEvent('keydown', e);
      if ('enter' === syntheticEvent.key.toLowerCase()) {
        // We pass the click through so that the button handles whether or not
        // to continue (within the onClick) or prevents the click (with disable).
        buttonRef.current?.click();
      }
    };

    document.addEventListener('keydown', listenForEnter);
    return () => {
      document.removeEventListener('keydown', listenForEnter);
    };
  }, []);

  return (
    <Button
      ref={buttonRef}
      value={value}
      onKeyDown={e => {
        // So that we don't double-fire the submit
        if (e.key === 'Enter') {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
      {...rest}
    />
  );
};
